import { css } from '@/styled-system/css';

export const trigger = css({
  appearance: 'none',
  background: 'transparent',
  border: 'none',
  // eslint-disable-next-line hotpads/no-magic-numbers -- Figma specifies a 9px radius for the mobile neighborhood thumbnail
  borderRadius: '9px',
  boxShadow: 'sm',
  cursor: 'pointer',
  flexShrink: 0,
  padding: 0,
  focusOutline: true,
  lg: {
    display: 'none',
  },
});
